import classNames from "classnames";
import { ExternalLink } from "components/icons/icons";
import { useMixpanelTracking } from "lib/hooks/useMixpanelTracking";
import type { Opening } from "../types";

export default function Openings({
  positions,
  heading,
}: {
  positions: Opening[];
  heading: string;
}) {
  const { track } = useMixpanelTracking();

  if (positions.length === 0) return null;
  return (
    <div className="mb-[70px]">
      <h2 className="text-black-rock mb-3 font-bold text-[18px]">{heading}</h2>
      {positions.length &&
        positions.map((position, i) => {
          return (
            <div
              key={i}
              className={classNames("text-[14px]", {
                "border-b border-t border-[#C8C8CC]": i === 0,
                "border-b border-[#C8C8CC]": i !== 0,
              })}
            >
              <div className="grid h-[132px] w-100 grid-cols-[5fr_1fr] grid-rows-[1fr_2fr_2fr] items-center gap-x-5 max-lg:py-[14px] md:grid-cols-[3fr_1fr] lg:h-[79px] lg:grid-cols-[0.6fr_2fr_1.8fr_0.7fr_0.2fr] lg:grid-rows-1">
                <p>{position.divisionName}</p>

                <p className="col-span-full line-clamp-2 font-bold lg:col-auto">
                  {position.positionDescription}
                </p>
                <div className="text-mono-40">
                  <p>
                    {position.areaName}
                    {position.countryName ? "," : null}
                  </p>
                  <p className="line-clamp-1">{position.countryName}</p>
                </div>
                <p className="justify-self-end whitespace-nowrap text-mono-40 [grid-column:_2_/_2] [grid-row:_1_/_1] lg:col-auto lg:row-auto lg:justify-self-auto">
                  {position.contractType}
                </p>
                <a
                  target="_blank"
                  rel="noreferrer noopener"
                  href={position.url}
                  className="justify-self-end lg:justify-self-auto"
                  onClick={async () => {
                    await track("Careers page click", {
                      "Position division name": position.divisionName,
                      "Position description": position.positionDescription,
                      "Click link": position.url,
                    });
                  }}
                >
                  <ExternalLink />
                </a>
              </div>
            </div>
          );
        })}
    </div>
  );
}
